module.exports = __webpack_public_path__ + "img/s7.a02d86ae.jpg";